import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetFullAnnotationSetsSearchQuery } from '../redux/slices/icardio';

const useHandleSearchRedirect = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const patientId = queryParams.get('patient_id');
  const snapshotId = queryParams.get('snapshot_id');
  const frameId = queryParams.get('frame_id');

  const { data, isLoading } = useGetFullAnnotationSetsSearchQuery({
    patient_id: patientId,
    snapshot_id: snapshotId,
    frame_id: frameId,
  });

  useEffect(() => {
    if (!patientId && !snapshotId && !frameId) return;

    if (data?.link) {
      const activeFrameIndex = data.activeFrameIndex || 0; // if no activeFrameIndex in the response, fallback to frame 0

      const fullLink = `/${data.link}?activeFrameIndex=${activeFrameIndex}`;

      navigate(fullLink, { replace: true });
    }
  }, [data, navigate]);

  return { isLoading };
};

export default useHandleSearchRedirect;
